export const color = (name, modifier = null) => `--${name}` + (modifier ? `-${modifier}` : '')
